import * as moment from 'moment-timezone';

export class DateUtil {
  static pstToUtc(date: string) {
    return moment.tz(date, 'America/Los_Angeles').tz('UTC').format('MM/DD/YYYY');
  }
}



// WEBPACK FOOTER //
// ./src/app/models/utils/date.util.ts